import { render, staticRenderFns } from "./EditDispatch.vue?vue&type=template&id=d9e528da&"
import script from "./EditDispatch.vue?vue&type=script&lang=js&"
export * from "./EditDispatch.vue?vue&type=script&lang=js&"
import style0 from "./EditDispatch.vue?vue&type=style&index=0&id=d9e528da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports